import { useUploadsProject } from 'hooks/useUploadsProject'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useState } from 'react'
import { useImagePickerContext } from '../ImagePickerContext'
import { reportError } from 'utils/error'
import { SelectedImage } from 'types'

export const useConfirm = () => {
  const context = useImagePickerContext()
  const { selectedImages, onConfirm, uploadImages, setSelectedImages } = context
  const workspaceId = useCurrentWorkspaceId()
  const [isConfirming, setIsConfirming] = useState(false)
  const uploadsProject = useUploadsProject(workspaceId)?.data?.project

  const confirm = async (images?: SelectedImage[]) => {
    if (!uploadsProject) return

    if (context.onBeforeConfirm) {
      const confirmed = await context.onBeforeConfirm(selectedImages)
      if (!confirmed) {
        return
      }
    }

    try {
      setIsConfirming(true)

      const files = await Promise.all(
        (images || selectedImages).map(async (image) => {
          const response = await fetch(image.url)
          const blob = await response.blob()
          return new File([blob], image.original_filename || 'filename', { type: blob.type || 'image/png' })
        }),
      )
      const uploadedImages = await uploadImages(files, context)
      setSelectedImages(uploadedImages)
      onConfirm(uploadedImages, context)
    } catch (error) {
      reportError(error)
    } finally {
      setIsConfirming(false)
    }
  }

  return { isConfirming, confirm }
}
